import { useMap } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';

interface Props {
	place: google.maps.places.PlaceGeometry | null;
}

export const MapHandler = ({ place }: Props) => {
	const map = useMap();

	useEffect(() => {
		if (!map || !place) return;
		if (place.viewport) {
			map.fitBounds(place.viewport);
		}
	}, [map, place]);

	return null;
};
